import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { CommercialService, UserService } from '@core/services';
import { User } from '@shared/models';

@Component({
    selector: 'app-account-select',
    templateUrl: './account-select.component.html',
    styleUrls: ['./account-select.component.css']
})
export class AccountSelectComponent implements OnInit, OnDestroy {
    user: User;
    isCommercial: any;

    routeSnapshot: ActivatedRouteSnapshot;
    routePath: string;

    subscription: Subscription;
    commercialSubscription: Subscription;
    @Output() switched: EventEmitter<any> = new EventEmitter();

    constructor(private _userService: UserService,
                private _commercialService: CommercialService,
                private route: ActivatedRoute) {

        this.routeSnapshot = route.snapshot;
        this.routePath = this.routeSnapshot.url[0].path;
    }

    ngOnInit() {

        this.subscription = this._userService.getUser().subscribe(user => {
            this.user = user
        });

        this.commercialSubscription = this._commercialService.getCommercialValue().subscribe(isCommercial => {
            this.isCommercial = isCommercial;
        });

    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.commercialSubscription.unsubscribe();
    }

    onChange(accountValue) {
        this._userService.setAccountIndex(accountValue);
        this.switched.emit(accountValue);
    }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/account-select/account-select.component.ts